export default {
    copy: 'Copy',
    edit: 'Edit',
    delete: 'Delete',
    leave: 'Leave',
    ariaLabel: 'Open workspace context menu'
}
